import { DateTime } from "luxon";

type TaskDueLabelTone = "default" | "error";

interface TaskDueLabel {
  label: string;
  tone: TaskDueLabelTone;
}

export function formatDaysUntilDue(dueDate: string | null | undefined): TaskDueLabel | null {
  if (!dueDate) return null;

  const due = DateTime.fromISO(dueDate).startOf("day");
  if (!due.isValid) return null;

  const today = DateTime.now().startOf("day");
  const dayDiff = Math.round(due.diff(today, "days").days);

  if (dayDiff < 0) {
    const daysAgo = Math.abs(dayDiff);
    return {
      label: daysAgo === 1 ? "1 day ago" : `${daysAgo} days ago`,
      tone: "error"
    };
  }

  if (dayDiff === 0) {
    return { label: "Today", tone: "default" };
  }

  if (dayDiff === 1) {
    return { label: "in 1 day", tone: "default" };
  }

  return { label: `in ${dayDiff} days`, tone: "default" };
}
